var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":_vm.loadingText}},[_c('vue-qr',{attrs:{"text":_vm.url,"logoSrc":_vm.logoSrc,"callback":_vm.initQrCode,"size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }